import script from "./CountdownTimer.vue?vue&type=script&setup=true&lang=js"
export * from "./CountdownTimer.vue?vue&type=script&setup=true&lang=js"

import "./CountdownTimer.vue?vue&type=style&index=0&id=68a1970d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68a1970d"]])

export default __exports__